import { IKeyboardRow } from '.';

export const standart: Array<IKeyboardRow> = [
  {
    keys: [
      { character: 'ABC', special: 'lang', span: 2 },
      { character: '123', special: 'symbols', keyboard: 'en', span: 2 },
      { character: 'Clear', special: 'clear', span: 2 },
    ],
  },
  {
    keys: [
      { character: '0', span: 1 },
      { character: '1', span: 1 },
      { character: '2', span: 1 },
      { character: '3', span: 1 },
      { character: '4', span: 1 },
      { character: '5', span: 1 },
    ],
  },
  {
    keys: [
      { character: '6', span: 1 },
      { character: '7', span: 1 },
      { character: '8', span: 1 },
      { character: '9', span: 1 },
      { character: '0', span: 1 },
      { character: '-', span: 1 },
    ],
  },
  {
    keys: [
      { character: '+', span: 1 },
      { character: '/', span: 1 },
      { character: ':', span: 1 },
      { character: ';', span: 1 },
      { character: '(', span: 1 },
      { character: ')', span: 1 },
    ],
  },
  {
    keys: [
      { character: '$', span: 1 },
      { character: '&', span: 1 },
      { character: '@', span: 1 },
      { character: '"', span: 1 },
      { character: '.', span: 1 },
      { character: ',', span: 1 },
    ],
  },
  {
    keys: [
      { character: '?', span: 1 },
      { character: '!', span: 1 },
      { icon: 'delete', special: 'delete', span: 4 },
    ],
  },
  {
    keys: [{ character: 'SPACE', special: 'space', span: 6 }],
  },
];

export default standart;
